import { useEffect, useMemo, useState } from 'react';
import { inputs } from '@ecosystem/newron-design-system';
import { WithListBox } from '@components/design/WithListBox';

const { HiddenList } = inputs;

export const WithHiddenListBox = ({
  isDisabled = false,
  label, // Label Button List
  options, // Options for the button list
  value, // Selected value option (actual is the label).
  onChange,
  width = 300,
  testId = 'button-menu',
  combobox = false, // If true, it will show the combobox
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const withIsDisabledOptions = useMemo(
    () => options.map((item) => ({ ...item, isDisabled: isDisabled })),
    [options, isDisabled],
  );

  const defaultOption = {
    dataType: 'NOT_AVAILABLE',
    feature: 'Not Available',
    label: 'Not Available',
    value: 'Not Available',
    isDisabled: isDisabled,
  };

  const findSelectedOption = (optionsList, selectedValue) => {
    const selectedItem = optionsList.find((item) => item.label === selectedValue) || null;
    return selectedItem ? { label: selectedItem.label, value: selectedItem.value ?? '', isDisabled } : defaultOption;
  };

  const initialSelectedOption = useMemo(
    () => findSelectedOption(withIsDisabledOptions, value),
    [withIsDisabledOptions, value],
  );

  const [selectedOption, setSelectedOption] = useState(initialSelectedOption);

  // Update useEffect to watch isDisabled and reset selectedOption accordingly
  useEffect(() => {
    if (initialSelectedOption?.label !== selectedOption?.label || isDisabled !== selectedOption?.isDisabled) {
      setSelectedOption(initialSelectedOption);
    }
  }, [initialSelectedOption, selectedOption, isDisabled]);

  return (
    <div className="flex items-center retail-insights-hidden-listbox">
      <div className="mr-0.5">{label}</div>
      <HiddenList
        label={selectedOption?.label || defaultOption.label}
        hoverColor={'super-light-orange'}
        width={'auto'}
        onClick={handleClick}
        isOpen={isOpen}
        isBold={true}
        disabled={isDisabled}
        size={'md'}
        testId={testId}
        style={{ padding: '12px', height: '40px', background: 'transparent' }}
      >
        <div className="flex items-center">
          <WithListBox
            listOption={withIsDisabledOptions.length === 0 ? [defaultOption] : withIsDisabledOptions}
            selectedOption={selectedOption || { label: 'Brands', value: 'Brands' }}
            setSelectedOption={setSelectedOption}
            onChange={onChange}
            width={width}
            combobox={combobox}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        </div>
      </HiddenList>
    </div>
  );
};